import React from "react";

import { type UserModel } from "@admin/domain/users/models/UserModel";
import { useOrderContext } from "@admin/pages/OrderEditor/OrderContext";
import {EditOrderData, EditOrderShippingInfoData} from "@admin/domain/orders/dto/EditOrderData";
import BaseModal from "@admin/components/Modal";
import UsersSearch from "@admin/components/UsersSearch";
import {getDefaultCountry} from "@admin/domain/countries/getDefaultCountry";
import {DeliveryMethodModel} from "@admin/domain/deliveryMethods/models/DeliveryMethodModel";

type Props = {
    closeModal: () => void;
};

export default function TargetUserModal({ closeModal }: Props) {
    const { order, setOrder, countries, deliveryMethods } = useOrderContext();
    const [selectedUser, setSelectedUser] = React.useState<UserModel>(order.target);

    const country = getDefaultCountry(countries);
    const defaultDeliveryMethod = deliveryMethods.values().next().value as DeliveryMethodModel;
    const [shippingInfo] = React.useState<EditOrderShippingInfoData>(
        order.shipping_info || {
            country_id: country.id,
            country_name: country.name,
            delivery_method_id: defaultDeliveryMethod.id,
            delivery_method_title: defaultDeliveryMethod.title,
            delivery_point_address: ``,
            delivery_point_id: null,
            edited_by_accounting_at: ``,
            edited_by_distributor_at: ``,
            email: ``,
            family_name: ``,
            locality_id: 0,
            locality_name: ``,
            name: ``,
            patronymic: ``,
            phone: ``,
            postcode: ``,
            street: ``,
            house: ``,
            flat: ``,
            updated_at: ``,
        },
    );
    const getPreparedShippingInfo = (user: UserModel): EditOrderShippingInfoData => {
        const preparedShippingInfo = shippingInfo;

        preparedShippingInfo.name = user.name;
        preparedShippingInfo.patronymic = user.patronymic;
        preparedShippingInfo.family_name = user.family_name;
        preparedShippingInfo.email = null;
        preparedShippingInfo.phone = null;

        return preparedShippingInfo;
    }

    const submit = (): void => {
        if (!selectedUser) {
            alert(`Получатель заказа не выбран`);
            return;
        }

        const preparedShippingInfo = !order.is_child ? getPreparedShippingInfo(selectedUser) : order.shipping_info;

        setOrder(
            (prev: EditOrderData): EditOrderData => ({
                ...prev,
                shipping_info: preparedShippingInfo,
                target: selectedUser,
            }),
        );
        closeModal();
    };

    return (
        <BaseModal
            closeModal={closeModal}
            title="Выбор другого Дистрибьютора"
            subTitle={
                <span>
                    Сейчас выбран: {order.target.personal_number}
                    {`, `}
                    {order.target.full_name}
                </span>
            }
            body={<UsersSearch onSelectUser={setSelectedUser} />}
            footer={
                <>
                    <button className="btn btn-secondary" onClick={closeModal}>
                        Закрыть
                    </button>
                    <button className="btn btn-primary" onClick={submit}>
                        Подтвердить
                    </button>
                </>
            }
        />
    );
}
